import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector:'ver-historial',
  templateUrl: './ver-historial.component.html',
  styleUrls:['./ver-historial.component.css']
})
export class VerHistorialComponent implements OnInit{
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['usuario', 'realizado', 'date'];
  dataSource = new MatTableDataSource<any>();
  search:string = ''
  historialOriginal = null

  constructor(
    public dialogRef: MatDialogRef<VerHistorialComponent>,
    @Inject(MAT_DIALOG_DATA) public historial: any
  ){}

  ngOnInit(){
    console.log(this.historial)
    this.cargarHistorial()
  }

  cargarHistorial() {
    this.historial.reverse()
    this.dataSource = new MatTableDataSource<any>(this.historial);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  filter(){
    this.historialOriginal === null ? this.historialOriginal = this.historial : null
    this.historial = this.historialOriginal
    this.historial = this.historial.filter((historia:any)=>JSON.stringify(historia).toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
    this.cargarHistorial()
  }

}
